import React, { useState } from 'react'
import { Box } from '@mui/material'

import { bankIconPublicPath } from '../constants/thaiBanks'

interface BankIconImgProps {
  code: string
  size?: number
}

export const BankIconImg: React.FC<BankIconImgProps> = ({ code, size = 24 }) => {
  const [hidden, setHidden] = useState(false)
  if (hidden || !code?.trim()) {
    return <Box sx={{ width: size, height: size, flexShrink: 0 }} aria-hidden />
  }
  return (
    <img
      src={bankIconPublicPath(code.trim())}
      alt=""
      width={size}
      height={size}
      style={{ objectFit: 'contain' }}
      onError={() => setHidden(true)}
    />
  )
}
